<template>
  <div :class="$style['space-200']"></div>
</template>

<script lang="ts" setup></script>

<style lang="postcss" module>
.space-200 {
  width: var(--space-150);
  height: var(--space-150);
}
</style>
